import React from 'react';
import get from 'lodash/get';
import cx from '../../utils/cx.js';
import Constants from '../../constants/Constants';

const ActionTypes = Constants.ActionTypes;
import QuestionStore from '../../stores/QuestionStore';
import QuestionsActionCreators from '../../actions/QuestionsActionCreators';
import Dropdown from './../form/Dropdown.react';
import CheckboxQuestion from './CheckboxQuestion.react';
import RadioQuestion from './RadioQuestion.react';
import Text from './../form/Text.react';
import TextareaQuestion from './TextareaQuestion.react';

function getStateFromStores() {
  return {
    question: QuestionStore.getLast(),
    saved: QuestionStore.getLastQuestionSaved(),
    skipped: QuestionStore.getLastQuestionSkipped(),
    loading: QuestionStore.getLoading(),
    lastActionType: QuestionStore.getLastActionType(),
    score: QuestionStore.getScore(),
    allAnswered: QuestionStore.getAllQuestionsAnswered(),
  };
}

class QuestionBlock extends React.Component {
	state = getStateFromStores();

	setFormData = (data) => {
	  this.setState({ formData: data });
	};

	componentDidMount() {
	  QuestionStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
	  QuestionStore.removeChangeListener(this._onChange);
	}

	handleSubmit = (e) => {
	  e.preventDefault();
	  QuestionsActionCreators.saveAnswer(this.state.formData, this.state.question._id);
	};

	handleSkip = (e) => {
	  e.preventDefault();
	  QuestionsActionCreators.skipQuestion(this.state.question._id);
	};

	render() {
	  if (typeof this.state.question === 'undefined' || this.state.question._id == null) {
	    return <div />;
	  }
	  let questionItem = null;
	  switch (this.state.question.type) {
	    case 'dropdown':
	      questionItem = (
  <Dropdown
    setFormData={this.setFormData}
    name={this.state.question.name}
    title={this.state.question.title}
    options={this.state.question.answers}
    wrapClass="g-b g-b--2of3 question-block-item"
    valueKey="_id"
    label="title"
  />);
	      break;
	    case 'checkbox':
	      questionItem = (
  <CheckboxQuestion
    setFormData={this.setFormData}
    name={this.state.question.name}
    title={this.state.question.title}
    answers={this.state.question.answers}
  />);
	      break;
	    case 'radio':
	      questionItem = (
  <RadioQuestion
    setFormData={this.setFormData}
    name={this.state.question.name}
    title={this.state.question.title}
    answers={this.state.question.answers}
  />);
	      break;
	    case 'text':
	      questionItem = (
  <Text
    wrapClass="g-b g-b--2of3 question-block-item"
    small
    setFormData={this.setFormData}
    title={this.state.question.title}
    name={this.state.question.name}
  />);
	      break;
	    case 'textarea':
	      questionItem = (
  <TextareaQuestion
    setFormData={this.setFormData}
    title={this.state.question.title}
    name={this.state.question.name}
  />);
	      break;
	    default:
	      questionItem = '';
	  }
	  let answerSaveLoading = false;
	  if (this.state.loading && this.state.lastActionType == ActionTypes.ANSWER_SAVE) {
	    answerSaveLoading = true;
	  }
	  let questionSkipLoading = false;
	  if (this.state.loading && this.state.lastActionType == ActionTypes.QUESTION_SKIP) {
	    questionSkipLoading = true;
	  }

	  let questionIcon = null;
	  let questionHasIcon = false;
	  if (this.state.question.icon) {
	    const svgString = `<svg class="icon icon--${this.state.question.icon}"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-${this.state.question.icon}"></use></svg>`;

	    questionIcon = (<div className="questionBlock-icon"><span className="vcenter"><span className="vcenter-inner" dangerouslySetInnerHTML={{ __html: svgString }} /></span></div>);

	    questionHasIcon = true;
	  }

	  return (
  <div className="questionBlock">
    <form onSubmit={this.handleSubmit}>
      <div className={cx([
						'block pam group',
						['loading', this.state.loading],
				])}
      >
        <div className="g-b g-b--1of1 mbm">
          <div className={cx([
									'g-b g-b--2of3 block-title prl pr',
									['questionBlock-hasIcon', this.state.question.icon],
							])}
          >
            {questionIcon}
            {this.state.question.title}
          </div>
          <div className="g-b g-b--1of3 question-block-button tar">
            <div className="g-b">
              <button
                type="submit"
                id="question-block"
                className={cx([
											'btn btn--a btn--small mll',
												['has-loader', answerSaveLoading],
											])}
              >
                { get(translations, 'txt: Saglabāt', '') }
              </button>
            </div>
          </div>
        </div>
        {questionItem}
        <div style={{ clear: 'both' }} />
        <div
          className="questionBlock-meter mts tooltip"
          data-tooltip={`${get(translations, 'txt: Anketa') + this.state.score}%`}
        >
          <div style={{ width: `${this.state.score}%` }} className="questionBlock-meter-inner" />
        </div>
      </div>
    </form>
  </div>
	  );
	}

	_onChange = () => {
	  this.setState(getStateFromStores());
	  let updateScore = this.state.score;

	  if ((this.state.saved || this.state.skipped) && !this.state.allAnswered) {
	    QuestionsActionCreators.loadNextUnanswered();
	  } else if (this.state.allAnswered) {
	    updateScore = 100;
	  }

	  $('#myProfileAnswerScoreNumber').html(updateScore);
	};
}

module.exports = QuestionBlock;
